/**
 * AdminAuditoriaView — Web Component (Light DOM)
 *
 * Vista completa de Sistema: Auditoría + Sesiones de Jugadores.
 * Contiene: tabs para separar logs de auditoría y sesiones de jugadores.
 * Migrado desde index.html (sección Sistema/Auditoría).
 */
import { t } from '../../services/i18n-admin.js';
import { icon } from '../../utils/icon.js';

export class AdminAuditoriaView extends HTMLElement {
    connectedCallback() {
        this.innerHTML = `
                    <!-- SISTEMA VIEW (solo superadmin) — Auditoría + Sesiones -->
                    <section class="view" id="view-sistema">
                        <div class="section-header">
                            <h3 class="section-title">${t('Sistema')}</h3>
                            <div class="view-tabs">
                                <button
                                    class="tab-btn active"
                                    data-tab="auditoria"
                                    data-action="app:switchTab"
                                    data-view="sistema"
                                >
                                    ${icon('file-text')} ${t('Auditoria')}
                                </button>
                                <button
                                    class="tab-btn"
                                    data-tab="sesiones"
                                    data-action="app:switchTab"
                                    data-view="sistema"
                                >
                                    ${icon('users')} ${t('Sesiones Jugadores')}
                                </button>
                                <button
                                    class="tab-btn"
                                    data-tab="series-tickets"
                                    data-action="app:switchTab"
                                    data-view="sistema"
                                    data-cap="admin.superadmin"
                                >
                                    ${icon('shield')} ${t('Series Tickets')}
                                </button>
                                <button
                                    class="tab-btn"
                                    data-tab="fleet-crashes"
                                    data-action="app:switchTab"
                                    data-view="sistema"
                                    data-cap="admin.superadmin"
                                >
                                    ${icon('alert-triangle')} ${t('Fleet Crashes')}
                                </button>
                                <button
                                    class="tab-btn"
                                    data-tab="fleet-whatsapp"
                                    data-action="app:switchTab"
                                    data-view="sistema"
                                    data-cap="admin.superadmin"
                                >
                                    ${icon('phone')} ${t('WhatsApp Config')}
                                </button>
                            </div>
                        </div>

                        <!-- TAB: Auditoría — renderizado por ListadoConFiltrosYExport -->
                        <div class="tab-content active" id="tab-sistema-auditoria"></div>

                        <!-- TAB: Sesiones de Jugadores -->
                        <div class="tab-content" id="tab-sistema-sesiones">
                            <!-- Cards de estadísticas -->
                            <div class="stats-cards" id="sesionesStatsCards" style="display:grid; grid-template-columns:repeat(auto-fit, minmax(180px, 1fr)); gap:12px; margin-bottom:20px;">
                                <div class="stat-card" style="background:var(--bg-secondary); border:1px solid var(--border-glass); border-radius:10px; padding:16px; text-align:center;">
                                    <div style="font-size:28px; font-weight:700; color:var(--accent-green);" id="statSesionesActivasAhora"><span class="skeleton-bar" style="display:inline-block;width:44px;height:26px;"></span></div>
                                    <div style="font-size:12px; color:var(--text-secondary); margin-top:4px;">${t('Activas ahora')}</div>
                                </div>
                                <div class="stat-card" style="background:var(--bg-secondary); border:1px solid var(--border-glass); border-radius:10px; padding:16px; text-align:center;">
                                    <div style="font-size:28px; font-weight:700; color:var(--accent-blue);" id="statSesionesTotalHoy"><span class="skeleton-bar" style="display:inline-block;width:44px;height:26px;"></span></div>
                                    <div style="font-size:12px; color:var(--text-secondary); margin-top:4px;">${t('Sesiones hoy')}</div>
                                </div>
                                <div class="stat-card" style="background:var(--bg-secondary); border:1px solid var(--border-glass); border-radius:10px; padding:16px; text-align:center;">
                                    <div style="font-size:28px; font-weight:700; color:var(--accent-yellow);" id="statDuracionPromedio"><span class="skeleton-bar" style="display:inline-block;width:44px;height:26px;"></span></div>
                                    <div style="font-size:12px; color:var(--text-secondary); margin-top:4px;">${t('Duracion promedio (min)')}</div>
                                </div>
                                <div class="stat-card" style="background:var(--bg-secondary); border:1px solid var(--border-glass); border-radius:10px; padding:16px; text-align:center;">
                                    <div style="font-size:28px; font-weight:700; color:var(--text-primary);" id="statJugadoresUnicos"><span class="skeleton-bar" style="display:inline-block;width:44px;height:26px;"></span></div>
                                    <div style="font-size:12px; color:var(--text-secondary); margin-top:4px;">${t('Jugadores unicos hoy')}</div>
                                </div>
                            </div>

                            <!-- Sesiones Activas -->
                            <div class="table-container" style="margin-bottom:20px;">
                                <div class="table-header">
                                    <h3>${t('Sesiones Activas')}</h3>
                                    <button class="btn btn-secondary" data-action="sistema:loadSesiones">
                                        ${icon('refresh-cw')} ${t('Actualizar')}
                                    </button>
                                </div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>${t('Cliente')}</th>
                                            <th>${t('Nodo')}</th>
                                            <th>${t('Dispositivo')}</th>
                                            <th>${t('Metodo')}</th>
                                            <th>${t('Inicio')}</th>
                                            <th>${t('Ultima actividad')}</th>
                                            <th>${t('Apuestas')}</th>
                                            <th>${t('Monto')}</th>
                                        </tr>
                                    </thead>
                                    <tbody id="sesionesActivasTable"></tbody>
                                </table>
                            </div>

                            <!-- Historial de Sesiones (componente: sort + timeline + búsqueda) -->
                            <div id="sesionesHistorialListado"></div>
                        </div>

                        <!-- TAB: Series de Tickets (superadmin only) -->
                        <div class="tab-content" id="tab-sistema-series-tickets" style="display:none">
                            <div class="table-container">
                                <div class="table-header">
                                    <h3>${t('Series de Tickets')}</h3>
                                    <div style="display:flex; gap:8px;">
                                        <button class="btn btn-secondary" data-action="sistema:refreshSeriesTickets">
                                            ${icon('refresh-cw')} ${t('Actualizar')}
                                        </button>
                                        <button class="btn btn-primary" data-action="sistema:crearSerieTickets">
                                            ${icon('plus')} ${t('Nueva Serie')}
                                        </button>
                                    </div>
                                </div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>${t('ID')}</th>
                                            <th>${t('Nombre')}</th>
                                            <th>${t('Master Key')}</th>
                                            <th>${t('Rango de tickets')}</th>
                                            <th>${t('Estado')}</th>
                                            <th>${t('Default')}</th>
                                            <th>${t('Tickets')}</th>
                                            <th>${t('Sorteos')}</th>
                                            <th>${t('Operadores')}</th>
                                            <th>${t('Acciones')}</th>
                                        </tr>
                                    </thead>
                                    <tbody id="seriesTicketsTableBody"></tbody>
                                </table>
                            </div>
                        </div>

                        <!-- TAB: Fleet Crashes (superadmin only) §1.3 dashboard cross-operador -->
                        <div class="tab-content" id="tab-sistema-fleet-crashes" style="display:none">
                            <div class="table-container">
                                <div class="table-header">
                                    <h3>${t('Crashes agregados (top regresiones por release)')}</h3>
                                    <button class="btn btn-secondary" data-action="sistema:loadFleetCrashes">
                                        ${icon('refresh-cw')} ${t('Actualizar')}
                                    </button>
                                </div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>${t('Exception')}</th>
                                            <th>${t('APK version')}</th>
                                            <th>${t('Total')}</th>
                                            <th>${t('Primero')}</th>
                                            <th>${t('Último')}</th>
                                        </tr>
                                    </thead>
                                    <tbody id="fleetCrashesTableBody"></tbody>
                                </table>
                            </div>
                        </div>

                        <!-- TAB: WhatsApp Accessibility Config (superadmin only) §1.3 -->
                        <div class="tab-content" id="tab-sistema-fleet-whatsapp" style="display:none">
                            <div class="table-container">
                                <div class="table-header">
                                    <h3>${t('WhatsApp Accessibility Config')}</h3>
                                    <div style="display:flex; gap:8px;">
                                        <button class="btn btn-secondary" data-action="sistema:loadFleetWhatsapp">
                                            ${icon('refresh-cw')} ${t('Actualizar')}
                                        </button>
                                        <button class="btn btn-primary" data-action="sistema:nuevaWhatsappConfig">
                                            ${icon('plus')} ${t('Nueva versión')}
                                        </button>
                                    </div>
                                </div>
                                <p style="font-size:12px; color:var(--text-secondary); padding:8px 16px;">
                                    Resource IDs del botón "Enviar" de WhatsApp / WhatsApp Business para automatización del POS.
                                    Cross-operador. WhatsApp publica el mismo APK globalmente — los IDs cambian entre versiones, no por país.
                                    Solo la fila marcada vigente es la que sirve <code>/api/app/whatsapp-config</code>.
                                </p>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>${t('Versión')}</th>
                                            <th>${t('Resource IDs')}</th>
                                            <th>${t('Notas')}</th>
                                            <th>${t('Creado')}</th>
                                            <th>${t('Vigente')}</th>
                                        </tr>
                                    </thead>
                                    <tbody id="fleetWhatsappTableBody"></tbody>
                                </table>
                            </div>
                        </div>
                    </section>
        `;
    }
}

customElements.define('admin-auditoria-view', AdminAuditoriaView);
